import React from "react";
import Countdown from "react-countdown";
import { Link } from "react-router-dom";
import { Flex } from "@100mslive/roomkit-react";
import { Cross, LogoIcon } from "../../icons";
import { EVENT_LEVEL } from "../../common/constants";

const EventRegCounterpopup = props => {
  const {
    setEnbableRegCounter,
    eventName,
    eventLevel,
    eventStartTime,
    eventDate,
    counterRender,
    hostedBy,
  } = props;

  return (
    <Flex
      align="center"
      direction="column"
      className="eventsPopup eventsPopup-sm2 attenderegisterationpopup"
    >
      <div className="eventsPopup-inner">
        <div className="eventsPopup-header">
          <div className="eventsPopup-header-desc text-primary">
            You Have Successfully Registered to {eventName}
          </div>

          <div
            className="eventsPopup-close"
            onClick={() => setEnbableRegCounter(false)}
          >
            <Cross />
          </div>
        </div>

        <div className="eventsPopup-content">
          <Flex
            justify="center"
            className="text-center attendee-area-col-left-content-counter-inpopup"
          >
            {eventLevel === EVENT_LEVEL?.webinar?.value &&
            eventStartTime &&
            eventDate ? (
              <Countdown date={eventStartTime} renderer={counterRender} />
            ) : null}
          </Flex>

          <div className="com-divider w-100"></div>

          <div className="eventsPopup-header-heading2 ">
            While you wait for the event,
            <br /> check out these investor communities
          </div>
        </div>
        {hostedBy ? (
          <div className="attendee-area-col-left-content-hostedlist">
            {hostedBy.map(item => (
              <Link
                target="_blank"
                to={item?.orgSlug ? `/company/${item?.orgSlug}` : null}
                className="attendee-area-col-left-content-hostedlist-row"
              >
                <div
                  className="attendee-area-col-left-content-hostedlist-row-logo"
                  style={{ backgroundColor: item?.orgLogoColor }}
                >
                  {item?.orgLogo ? (
                    <img
                      src={item?.orgLogo}
                      alt={`Logo - ${item?.orgName} `}
                      width={50}
                      height={50}
                    />
                  ) : (
                    <LogoIcon />
                  )}
                </div>
                <div className="attendee-area-col-left-content-hostedlist-row-name">
                  {item?.orgName}
                </div>
              </Link>
            ))}
          </div>
        ) : null}
      </div>
    </Flex>
  );
};
export default EventRegCounterpopup;
